export const dropCookie = (key, value, seconds) => {
        // document.cookie = "testcookie=testcookie"
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000*seconds;
        now.setTime(expireTime);
        document.cookie =  key + '=' + value + ';expires=' + now.toUTCString()+";path=/"
}